import styled from 'styled-components';

export const ErrorsContainer = styled.div`
  padding: 0 0 20px 0;
`;
